import { provideModuleWidgets, SOFTLINE_WIDGET_OUTLET_DASHBOARD } from '@softapps/core';
import { SOFTLINE_PERMISSION_CHECKLISTE } from '../checkliste.shared';

export function provideChecklistWidget() {
  return provideModuleWidgets([
    {
      outletNames: [SOFTLINE_WIDGET_OUTLET_DASHBOARD],
      group: 'allgemein',
      loadComponent: () =>
        import('./checklist-widget/checklist-widget.component').then(
          (m) => m.ChecklistWidgetComponent
        ),
      permission: `${SOFTLINE_PERMISSION_CHECKLISTE}.WIDGET`,
    },
  ]);
}
